var col_max = 0;
var item_width = 350;
var col_arr = [];
var col_max_last = 0;
var div_adaptive_init = 0;
var sel_clt = 0;

function div_adaptive_collapse() {
	$('.data .wrap .item').removeClass('item_act');
	window.allow_item_show = false;
}

function div_adaptive(need) {
	col_max = Math.floor(($(window).width() - 80) / 345); // 397
	if (col_max == 0) col_max = 1;
	let item_width = 320;
	let item_width_2 = 160;
	let item_marg = 30;
	if ($(window).width() < 768) {
		col_max = 2;
		item_width = 0.5 * $(window).width() - 30;
		item_width_2 = 10;
		item_marg = 10;
	}
	//item_width = Math.floor(($(window).width() - 80)/col_max) - 25;
	//if (item_width > 450) item_width = 450;
	if (col_max_last == col_max && !need && col_max_last > 2) return;
	col_max_last = col_max;
	window.allow_item_show = true;
	$('.data .wrap').css({width: ((item_width + 25) * col_max - 25) + 'px'});
	var def_pos = Math.floor(((item_width + 25) * col_max - 25) / 2 - item_width / 2);
	var wh = $(window).height();
	var cur_i = 0;
	//var cur_j = 0;
	var cur_l = 0;
	var cur_x_dif = 0;
	//if (div_adaptive_init && ($(window).width() > 480)) $('.data .wrap .item').addClass('item_ani');
	cur_i = 0;
	cur_j = 0;
	for (var i = 0; i < col_max; i++) col_arr[i] = 0;
	cur_l = $('.data .wrap .item').not('.item_hid').length;
	if (cur_l < col_max) {
		cur_x_dif = Math.floor((col_max - cur_l) * (item_width + 25) / 2);
	} else {
		cur_x_dif = 0;
	}
	$('.data .wrap .item_hid').css({left: '50%', top: 0});
	$('.data .wrap .item').not('.item_hid').each(function () {
		var imin = 0;
		for (var i = 0; i < col_max; i++) {
			if (col_arr[i] < col_arr[imin]) imin = i;
		}
		$(this).css({left: cur_x_dif + imin * (item_width + 25) + item_width_2 + 'px', top: col_arr[imin] + 'px'}); //, width: item_width
		col_arr[imin] += ($(this).outerHeight() + item_marg);
	});
	filter_item_show();
	var imax = 0;
	for (var i = 0; i < col_max; i++) {
		if (col_arr[i] > col_arr[imax]) imax = i;
	}
	$('.data .wrap').css({height: col_arr[imax] + 'px'});
	div_adaptive_init = 1;
}

window.allow_item_show = true;

function filter_item_show() {
	if (!window.allow_item_show) return;
	var o = $('.data .wrap .item').not('.item_hid').not('.item_act').filter(':first');
	if (o.length) {
		o.addClass('item_act');
		window.setTimeout('filter_item_show()', 200);
	}
}

function filter_work(id_type) {
	sel_clt = id_type;
	if (id_type) {
		$('.data .wrap div.item').addClass('item_hid').filter('.item_t' + id_type).removeClass('item_hid');
	} else {
		$('.data .wrap div.item').addClass('item_hid').filter('.item_top').removeClass('item_hid');
	}
	$('.data .wrap div.item_hid').appendTo($('.data .wrap'));
	div_adaptive(1);
}

function step14_show_more() {
	if (!sel_clt && window.allow_scroll && $('.data .wrap .item_hid').length) {
		window.allow_scroll = false;
		$('.data .wrap .item_hid:lt(' + col_max_last + ')').removeClass('item_hid');
		div_adaptive(1);
		window.setTimeout(function () {
			window.allow_scroll = true;
			if ($(window).scrollTop() > $('body').height() - $(window).height() - 500) {
				step14_show_more();
			}
		}, col_max_last * 200);
	}
}

$(document).ready(function () {
	if ($('.data .wrap').length) {
		window.setTimeout(div_adaptive, 200);
		$(window).on('resize', function () {
			if (window.resizePTM) window.clearTimeout(window.resizePTM);
			window.resizePTM = window.setTimeout(div_adaptive, 100);
		});
	}
});

function client_go(el, url) {
	window.open(url)
}